import * as types from './types';

const INITIAL_STATE = {
  getConfiguration: {
    loading: false,
    data: null,
    errors: null,
  },
  postSaveConfiguration: {
    loading: false,
    data: null,
    errors: null,
  },
  postTestConnection: {
    loading: false,
    data: null,
    errors: null,
  },
  postExport: {
    loading: false,
    data: null,
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.POWERSCHOOL_EXPORT_GETCONFIGURATION_LOADING: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, loading: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_GETCONFIGURATION_SUCCESS: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, data: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_GETCONFIGURATION_ERROR: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, errors: action.payload },
      };
    }

    case types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_LOADING: {
      const { postSaveConfiguration } = state;
      return {
        ...state,
        postSaveConfiguration: {
          ...postSaveConfiguration,
          loading: action.payload,
        },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_SUCCESS: {
      const { postSaveConfiguration } = state;
      return {
        ...state,
        postSaveConfiguration: {
          ...postSaveConfiguration,
          data: action.payload,
        },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_ERROR: {
      const { postSaveConfiguration } = state;
      return {
        ...state,
        postSaveConfiguration: {
          ...postSaveConfiguration,
          errors: action.payload,
        },
      };
    }

    case types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_LOADING: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, loading: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_SUCCESS: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, data: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_ERROR: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, errors: action.payload },
      };
    }

    case types.POWERSCHOOL_EXPORT_POSTEXPORT_LOADING: {
      const { postExport } = state;
      return {
        ...state,
        postExport: { ...postExport, loading: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTEXPORT_SUCCESS: {
      const { postExport } = state;
      return {
        ...state,
        postExport: { ...postExport, data: action.payload },
      };
    }
    case types.POWERSCHOOL_EXPORT_POSTEXPORT_ERROR: {
      const { postExport } = state;
      return {
        ...state,
        postExport: { ...postExport, errors: action.payload },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/state/reducer.js